import React from 'react';
import PropTypes from 'prop-types';
import QuestionContent from './QuestionContent';

const QuestionPreview = (props) => {
  const { items, questionId, onLoadingStart, onLoadingEnd } = props;

  return (
    <QuestionContent
      key="question-content-preview"
      items={items}
      questionId={questionId}
      onLoadingStart={onLoadingStart}
      onLoadingEnd={onLoadingEnd}
    />
  );
};

QuestionPreview.propTypes = {
  items: PropTypes.array.isRequired,
  questionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
  onLoadingStart: PropTypes.func,
  onLoadingEnd: PropTypes.func,
};

QuestionPreview.defaultProps = {
  onLoadingStart: () => {},
  onLoadingEnd: () => {},
};

export default QuestionPreview;
